import classNames from 'classnames';

import { checkIsErrorExist } from '../helpers';
import { roleTemplates } from '../templates';
import FormItem from './form-item';
import s from './styles.module.scss';

import type { IRpmPatientFormActivity, TTemplateRoleData } from '../types';
import type { FC } from 'react';
import type { ReadingTemplateRoles } from 'infrastructure/enums';
import type { FormikProps } from 'formik';

interface TemplateProps {
  currentReadingType: IRpmPatientFormActivity;
  templateRole: ReadingTemplateRoles;
  formik: FormikProps<TTemplateRoleData[ReadingTemplateRoles]>;
}

const Template: FC<TemplateProps> = ({
  currentReadingType,
  templateRole,
  formik,
}) => {
  const { readingType: type, globalStatus } = currentReadingType;
  const currentTemplate = roleTemplates[templateRole][globalStatus]?.[type];
  const fieldErrors = formik.errors[globalStatus];
  const errors = typeof fieldErrors === 'string' ? undefined : fieldErrors;
  const errorsByType = errors?.[type];

  return currentTemplate?.map((formItem) => {
    const err = checkIsErrorExist(formItem, errorsByType);
    return (
      <div
        className={classNames(s.item, { [s.error]: err })}
        key={formItem.key}
      >
        <FormItem
          item={formItem}
          formik={formik}
          readingStatus={globalStatus}
          readingType={type}
        />
      </div>
    );
  });
};
export default Template;
